import { combineReducers } from 'redux';

import cgSlipReducer from './cgSlipReducer';
import cgListReducer from './cgListReducer';
import cgCouponsReducer from './cgCouponsReducer';
import cgPlayReducer from './cgPlayReducer';
import cgRulesReducer from './cgRulesReducer';
import cgDrawsReducer from './cgDrawsReducer';

export default combineReducers({
  cgRules: cgRulesReducer,
  cgSlip: cgSlipReducer,
  cgList: cgListReducer,
  cgCoupons: cgCouponsReducer,
  cgPlay: cgPlayReducer,
  cgDraws: cgDrawsReducer
});
